import surfIcon from "../static/surf-icon.svg"
import css from "../style.module.scss"

export const Logo = () => (
  <div className={css["logo-container"]}>
    <h2 className={css.logo}>
      <img src={surfIcon} alt="Surf-Forecast" width={40} className={css["logo-icon"]} />
      Surf<span className={css.pro}>Pro</span>
    </h2>
  </div>
)
